import Vue from 'vue';
import VueRouter from 'vue-router';

import PageNotFound from '../views/pages/error-pages/PageNotFoundView';
import Inicio from '@/views/pages/inicio/InicioPage.vue';
import DescuentoPage from '@/views/pages/descuento-datos/DescuentoPageView.vue';
import SorteoPage from '@/views/pages/sorteo/SorteoPageView.vue';
import TerminosCondiciones from '@/views/pages/descuento-datos/TerminosCondicionesView.vue';
import BasesCondiciones from '@/views/pages/descuento-datos/BaseCondicionesView.vue';
import RedimiblesView from '@/views/pages/banners/RedimiblesView.vue';




Vue.use(VueRouter)


const routes = [
  {
    path: '*',
    name: 'pageNotFound',
    component : PageNotFound
  },
  {
    path: '/', 
    redirect: { name: 'promociones' }
  },
  {
    path: '/promociones',
    name: 'promociones',
    component: Inicio,
    children: [
      {
        path: '/promociones/descuento',
        name: 'descuento',
        components: {
          contentRouter: DescuentoPage
        }
      }, 
      {
        path: '/promociones/sorteo',
        name: 'sorteo',
        components: {
          contentRouter: SorteoPage
        }
      }, 

      {
        path: '/promociones/redimibles',
        name: 'redimibles',
        components: {
          contentRouter: RedimiblesView
        }
      }, 
      
      
      {
        path: '*',
        components: {
          contentRouter: PageNotFound
        }
      } 
    ]
  },
  {
    path: '/terminoscondiciones',
    name: 'terminoscondiciones',
    component: TerminosCondiciones
  },

  {
    path: '/basesyCondiciones',
    name: 'basesyCondiciones',
    component: BasesCondiciones
  },
  
  /* {
    path: '/descuento',
    name: '',
    component: ContabilidadPage,
    children: [
      {
        path: 'operaciones/facturacionGad',
        name: 'FacturacionGad',
        components: {
          contentRouter: FacturacionGad
        }
      }, 
      {
        path: '*',
        components: {
          contentRouter: PageNotFound
        }
      } 
    ]
  }, */

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
